"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interop = void 0;
/* eslint-disable */
function interop(module) {
    return (module === null || module === void 0 ? void 0 : module.__esModule) ? module.default : module;
}
exports.interop = interop;
